import {
  LOAD_HEADER,
  LOAD_HEADER_COMPLETE,
  LOAD_HEADER_ERROR,
  LOGOUT,
  SET_QUERY_STRING
} from '../constants/actionTypes';
import { getHeader, setTypology } from '../utils/apiHeader';

export const loadHeaderComplete = response => ({
  type: LOAD_HEADER_COMPLETE,
  menuBurguer: response
});

export const loadHeaderError = {
  type: LOAD_HEADER_ERROR
};

export const loadHeader = typology => dispatch => {
  dispatch({ type: LOAD_HEADER });
  setTypology(typology);
  return getHeader(typology)
    .then(response => dispatch(loadHeaderComplete(response)))
    .catch(() => dispatch(loadHeaderError));
};

export const typologyUser = typology => {
  setTypology(typology);
};

export const logout = () => dispatch => {
  dispatch({ type: LOGOUT });
};

export const setQueryString = (query, dispatch) => {
  dispatch({ type: SET_QUERY_STRING, searchQuery: query });
};
